module.exports = __webpack_public_path__ + "img/menuIcon.3af3d34d.png";